export const MAP_RESET = "MAP_RESET" as const;
export const MAP_MARKER_SET = "MAP_MARKER_SET" as const;
